import React from "react";

const AccountHeading = ({title}) => {
    return <h4 className="text-dark font-weight-bold mb-3">{title}</h4>
}

export default AccountHeading;